/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2022, Zumper
 */

import { getUser } from '@zcode-ui/web-zumper-global-state'
import { SHORT_TERM_CLICK_OUT, event, getEntityProperties } from '@zcode-ui/web-zumper-integrations'
import { getRouteProps } from '@zcode/nr/es/shared/packages/history-middleware'
import type { Listable, MaybeEmptyProperty } from '@zcode/state-type'
import type { MaybeEmpty } from '@zcode/utility-types'
import { routes } from '@zcode/zumper-routes'
import { getCurrentLocation } from '../../../inspectors/index'
import type { Dispatch, GetState } from '../../../modules/types'
import { formatDateForFilter } from '../../filters/helpers/index'
import { getFilters } from './getFilters'
import { getTraktorPageType } from './trackDetailEvent'

export const trackShortTermClickOut =
  ({
    additionalProps,
    entity,
    dates,
  }: {
    entity: MaybeEmpty<Listable> | MaybeEmptyProperty
    additionalProps?: any
    dates?: readonly Date[]
  }) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState()

    const user = getUser(state)
    const startDate = formatDateForFilter(dates?.[0]) ?? null
    const endDate = formatDateForFilter(dates?.[1]) ?? null
    const filters = getFilters(state, entity)
    const location = getCurrentLocation(state)

    const entityProps = getEntityProperties(entity, state)
    const { match } = dispatch(getRouteProps({ routes }))
    const props = {
      pageType: getTraktorPageType(entity, match, state),
      ...entityProps,
      ...additionalProps,
    }

    dispatch(
      event({
        name: SHORT_TERM_CLICK_OUT,
        props,
        user,
        filters: { ...filters, startDate, endDate },
        location,
      })
    )
  }
